document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'bf_collection_path';
  const currentPath = window.location.pathname;

  const collectionTitle =
    window.collectionData?.breadcrumb_text?.trim() || window.collectionData?.title;

  const templateInfo = window.currentTemplate || {};
  let templateType = 'unknown';

  if (templateInfo.name === 'collection' && !templateInfo.suffix) {
    templateType = 'default-collection';
  }

  if (templateInfo.name === 'collection' && templateInfo.suffix === 'collection-multi-add-cart') {
    templateType = 'multi-add-cart';
  }

  if (templateInfo.name === 'collection' && templateInfo.suffix === 'category-landing') {
    templateType = 'category-landing';
  }

  function getCollectionHandle(url) {
    if (!url || !url.includes('/collections/')) return null;
    return url.split('/collections/')[1].split('/')[0];
  }

  const isCollectionPage = /^\/collections\/[^\/]+$/.test(currentPath);
  const isProductPage = currentPath.includes('/products/');
  const isPdfPage = currentPath.endsWith('.pdf');

  const isValidBreadcrumbPage = isCollectionPage || isProductPage || isPdfPage;

  const currentHandle = getCollectionHandle(currentPath);

  let path = [];

  try {
    path = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    path = [];
  }

  if (!isValidBreadcrumbPage) {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }

  if (isCollectionPage && currentHandle) {
    const last = path[path.length - 1];
    const lastTemplate = last ? last.template : null;

    if (lastTemplate === 'multi-add-cart' && templateType === 'multi-add-cart') {
      if (last && last.handle !== currentHandle) {
        path = [];
      }
    }

    if (lastTemplate === 'multi-add-cart' && templateType === 'default-collection') {
      const index = path.findIndex((p) => p.handle === currentHandle);
      if (index !== -1) {
        path = path.slice(0, index + 1);
      } else {
        path = [];
      }
    }

    if (lastTemplate === 'multi-add-cart' && templateType === 'category-landing') {
      path = [];
    }

    if (lastTemplate === 'default-collection' && templateType === 'default-collection') {
      const index = path.findIndex((item) => item.handle === currentHandle);
      if (index !== -1) {
        path = path.slice(0, index + 1);
      } else {
        const fromMenu = isMenuCollection(currentHandle);
        if (fromMenu) {
          path = [];
        }
      }
    }

    if (lastTemplate === 'default-collection' && templateType === 'category-landing') {
      path = [];
    }

    if (lastTemplate === 'category-landing' && templateType === 'category-landing') {
      path = [];
    }

    if (lastTemplate === 'category-landing' && templateType === 'default-collection') {
      const parentHandle = getParentMenuHandle(currentHandle);
      if (parentHandle) {
        const last = path[path.length - 1];
        if (!last || last.handle !== parentHandle) {
          path = [];
        }
      } else {
        path = [];
      }
    }

    const exists = path.some((p) => p.handle === currentHandle);

    if (!exists) {
      const item = {
        handle: currentHandle,
        title: collectionTitle,
        template: templateType,
      };
      path.push(item);
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(path));
  }

  const breadcrumbNav = document.querySelector('.cstm-brdcrumb-section nav');

  if (!breadcrumbNav) {
    return;
  }

  const items = breadcrumbNav.querySelectorAll('.breadcrumbs__item');
  const homeItem = items[0];

  if (!homeItem) return;

  // On a PDP the server renders Home + Product (no collection middle).
  // We keep BOTH and only insert collection-path items BETWEEN them.
  // On a collection page the server renders only the current collection
  // as the final item; we rebuild it from sessionStorage to reflect the
  // user's actual navigation path.
  // Guard: require items.length > 1 so a PDP that somehow rendered only Home
  // (e.g. unpublished/draft product) doesn't treat homeItem as productItem,
  // which would cause path items to be inserted BEFORE Home.
  const productItem = isProductPage && items.length > 1 ? items[items.length - 1] : null;

  items.forEach((el) => {
    if (el === homeItem) return;
    if (el === productItem) return;
    el.remove();
  });

  let lastElement = homeItem;

  path.forEach(function (item, index) {
    const isLastCollection = index === path.length - 1 && !isProductPage;

    const wrapper = document.createElement('li');
    wrapper.className = 'breadcrumbs__item';

    let element;

    if (isLastCollection) {
      element = document.createElement('a');
      // Bare path, matching the menu link; ?page=N made it a "different destination".
      element.href = currentPath;
      element.setAttribute('aria-current', 'page');
      element.className = 'breadcrumbs__current';
    } else {
      element = document.createElement('a');
      element.href = '/collections/' + item.handle;
      element.className = 'breadcrumbs__link';
    }

    element.textContent = item.title;

    if (isLastCollection) {
      element.style.fontWeight = 'var(--font-weight-bold)';
    }

    wrapper.appendChild(element);

    if (productItem) {
      // PDP: insert path items BEFORE the server-rendered Product item
      productItem.parentNode.insertBefore(wrapper, productItem);
    } else {
      // Collection page: append after the previous item
      lastElement.insertAdjacentElement('afterend', wrapper);
      lastElement = wrapper;
    }
  });
});

function isMenuCollection(handle) {
  const menuLinks = document.querySelectorAll('.znt-featured-menu a[href*="/collections/"]');

  for (const link of menuLinks) {
    const href = link.getAttribute('href');
    if (!href) continue;

    const h = href.split('/collections/')[1]?.split('?')[0];
    if (h === handle) {
      return true;
    }
  }

  return false;
}

function getParentMenuHandle(handle) {
  const links = document.querySelectorAll(".znt-featured-menu_main-list a[href*='/collections/']");

  for (const link of links) {
    const href = link.getAttribute('href');
    if (!href) continue;

    const childHandle = href.split('/collections/')[1]?.split('?')[0];

    if (childHandle === handle) {
      const parentLi = link.closest('.znt-featured-menu_main-list-item');
      if (!parentLi) return null;
      const parentLink = parentLi.querySelector("a[href*='/collections/']");
      if (!parentLink) return null;
      const parentHref = parentLink.getAttribute('href');
      return parentHref.split('/collections/')[1]?.split('?')[0];
    }
  }

  return null;
}
